<template>
  <div class="house">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>分享与推送</el-breadcrumb-item> -->
          <el-breadcrumb-item>图片浏览</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>{{atlasInfo.name}}</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div v-if="isUpload"
           class="head disflex">
        <div class="left">
          <p><span style="font-weight:bold;">{{picInfoShare.title}}</span> / 共<span>{{sharePic.length}}</span>张 </p>
        </div>
        <div class="right disflex">
          <p>
            <span style="font-weight:bold;">创建时间：</span>
            {{picInfoShare.createAtMY}}
          </p>
          <p>
            <span style="font-weight:bold;">创建人：</span>
            {{userInfo.name}}
          </p>
          <!-- <el-button>批量管理</el-button> -->
          <el-button @click="$router.go(-1)">返回</el-button>
          <!-- <el-button v-if="powersObj.createAtlas" @click="unFormatAtlasClick">取消归档</el-button>
          <el-button v-if="powersObj.createAtlas" @click="openUpload" style="background-color: #185ED3;color:#fff;border-radius:5px;"><i class="el-icon-plus"></i> 补充图片</el-button>-->
        </div>
      </div>

      <!-- <div v-if="!isUpload" class="uploadhead disflex">
        <h4>图片上传</h4>
        <el-button class="btn"><i class="el-icon-plus"></i> 添加图片</el-button>
      </div>-->

      <div class="piclist">
        <template v-if="picFlag">
          <!-- <div v-for="(e,i) in picList">
            <img height="193" v-for="(e,i) in 6" :key="'1'+i" :src="require('@/assets/piclist/pic'+ (i+10) +'.jpg')" alt="">
          </div>-->
          <section>
            <div @click="openDialog(index,item)"
                 class="img-wrapper"
                 v-for="(item, index) in sharePic"
                 :key="index">
              <el-image class="img"
                style="height: 150px"
                        @contextmenu.prevent="rightShow($event)"
                        ondragstart="return false;"
                        v-if="item.type=='pic'"
                        :src="item.src" />
              <video
                  style="height: 150px"
                  
                  v-if="item.type === 'video'"
                  :src="item.src"
                ></video>
                <!-- 播放 -->
              <div v-if="item.type == 'video'" class="play">
                <img src="@/assets/piclist/playb.png" alt />
              </div>
              <!-- 选用图片 -->
              <!-- <el-tooltip class="item"
                          effect="dark"
                          content="选用图片"
                          placement="top">
                <div @click.stop="lovePicOut(item,index)"
                     v-if="item.fileInfo.src !== 'error' && powersObj.selectPicture"
                     class="love">
                  <img v-if="loveList.indexOf(item.id) === -1"
                       src="@/assets/piclist/love.png"
                       alt />
                  <img v-if="loveList.indexOf(item.id) > -1"
                       src="@/assets/piclist/lovec.png"
                       alt />
                </div>
              </el-tooltip> -->
            </div>

            <img v-if="showLoading"
                 class="myloading"
                 width="200px"
                 src="@/assets/blue-preloader.gif"
                 alt />
          </section>
        </template>
        <template v-if="!picFlag">
          <div class="nopic">
            <img src="@/assets/piclist/nonr.png"
                 alt />
          </div>
        </template>
      </div>
    </div>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisible"
               width="90%"
               top="12vh"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisible = false"
           class="close">
        <img :style="{'margin-top':displayResolution < 1600 ? '-2px':'0px'}"
             src="@/assets/picbrowse/close.png"
             alt />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="imgBj"
               ref="imgBj">
            <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 height="98%"
                 @click="seeBigSmall"
                 v-if="choosePicMsg.type=='pic'"
                 v-lazy="choosePicMsg.src">
            <video-player
              v-else
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              style="width: 70%; height: 100%"
              :playsinline="true"
              :options="playerOptions"
            ></video-player>
            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="position:absolute; bottom:20px; left:45%; font-size: 30px;"></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position:absolute; bottom:20px;font-size: 30px;"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <p class="picinfleft">
            {{picInfoShare.title}} / 共
            <span>{{sharePic.length}}</span>张
          </p>
          <div class="picinfright disflex">
            <!-- <div v-if="powersObj.createAtlas" @click.stop="lovePic" class="disflex spare" :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}">
              <div class="icon"></div>
              <p>选用</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              <p>设为封面</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="deletePic" class="disflex delete">
              <div class="icon"></div>
              <p>移出</p>
            </div>-->
            <!-- <div @click.stop="dev" class="disflex download">
              <div class="icon"></div>
              <p>下载原图 <span style="font-size:12px;"> (已下载{{choosePicMsg.downloadCount}}次)</span> </p>
            </div>-->
          </div>
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display:flex;transition:1s;">
            <div @click="picListClick(e,i)"
                 v-for="(e,i) in sharePic"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{backgroundImage:'url(' + e.picThumbWh160 + ')',cursor:'pointer'}"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   v-if="choosePicMsg.type == 'pic'"
                   :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active':'picimg'">
                </div>
                   <video
                      v-else
                      :src="sharePic.src"
                      style="width: 70%; height: 100%"
                      
                    ></video>
                  </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>

        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{picExif.CreateAtMy || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">所属资源库</div>：
          <span>{{choosePicMsg.libName || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{picExif.Make || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>：
          <span>{{picInfo.picW}}*{{picInfo.picH}}像素</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>：
          <span>{{picInfo.fileSize}}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{picInfo.format}}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>{{picExif.ExposureTime}}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{picExif.ISOSpeedRatings || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{picExif.FocalLength || '暂无'}}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{choosePicMsg.desc}}</p>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.labels.length > 0 && !isSimple">
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;"
               v-for="(e,i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{e}}</el-tag>
          </div>
        </div>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{'0'}}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{'0'}}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{'0'}}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { setUserSetting, getUserSetting } from "@/api/config";

import { getDate, formatConversion } from "@/plugins/getdate";
import { picPrefix } from "@/constants/piccommon";
import { getPicture, getPictures } from "@/api/picture";
import { getVideos } from "@/api/video";
import { getUser } from "@/api/user";
import { getFileInfoById } from "@/api/file";

import { powersObj } from "@/constants/powers";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
import { getLib } from "@/api/lib";

export default {
  components: {},
  computed: {
    ...mapGetters(["createUid"])
  },
  watch: {
    "$store.state.user.isUpload" (data) {
      this.isUpload = data;
    },
    "$store.state.user.loveList" (data) {
      this.loveList = data;
    }
  },
  data () {
    return {
      //选用图片
      loveList: [],
      shareVideo:[],





      seeFull: false,
      picInfoShare: "",
      userInfo: "",
      sharePic: [],

      //权限
      powersObj,
      //图片选用
      loveList: [],
      //图片浏览
      choosePicMsg: { isLove: false, labels: [] },
      picAllListFlag: -1,
      dialogVisible: false,
      imgLoading: false, //图片加载
      scroll: 0,
      picCha: -1,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      atlasInfo: {},
      picPrefix,
      busy: false,
      isUpload: this.$store.state.user.isUpload,
      picDescribe: "",
      gallery: "",
      picname: "",
      explain: "",
      visibility: "公开",
      picFlag: true,
      picList: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      visibilityList: [
        {
          value: "公开",
          label: "公开"
        },
        {
          value: "私密",
          label: "私密"
        }
      ],
      total: 0,
      showLoading: false,
      pageSize: 25,
      page: 0,

      createUserInfoname: "",
      isRefresh: false,

      displayResolution: "",

      haslovechange: false,

      picInfo: {},
      picExif: {},

      picTimes: 1,
      picDeg: 0,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      showMessageLeft: false,
      showMessageRight: false,
    };
  },
  methods: {
    ...mapActions(["setIsUpload"]),
    ...mapActions(["setLoveList"]),


    //选用图片
    lovePicOut (e, i) {
      if (e.fileInfo.picThumbH160 == 'error') {
        this.$message.warning('图片生成失败，无法添加到选用图片!');
        return false
      }

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)


      if (picLoveArray == null) {
        this.sharePic[i].isLove = false
      } else {
        for (let index = 0; index < picLoveArray.length; index++) {
          if (picLoveArray[index].id === this.sharePic[i].id) {
            this.sharePic[i].isLove = true
          }
        }
      }

      if (!this.sharePic[i].isLove) {
        // if (picLoveArray !== null) {
        //   if (picLoveArray.length > 34) {
        //     this.$message.warning('选用图片最多35张!');
        //     return false
        //   }
        // }

        this.loveList.push(this.sharePic[i].id)

        this.sharePic[i].isLove = true


        if (!picLoveArray) {
          let pL = []
          pL.push(this.sharePic[i])
          sessionStorage.setItem("picLove", JSON.stringify(pL));

          this.setUserSettingAsync(this.createUid, 'picLove', { value: this.sharePic[i].id })
          this.$message.success("添加成功")
        } else {
          picLoveArray.push(this.sharePic[i])
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("添加成功")
        }
      } else {
        this.loveList.splice(this.loveList.indexOf(this.sharePic[i].id), 1)


        this.sharePic[i].isLove = false


        if (picLoveArray.length === 1) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.$message.success("移出成功")
        } else {
          let f
          for (let index = 0; index < picLoveArray.length; index++) {
            if (this.sharePic[i].id === picLoveArray[index].id) {
              f = i
            }
          }
          // console.log(picLoveArray)
          picLoveArray.splice(f, 1)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("移出成功")
        }

      }


    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },



    seeBigSmall () {
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
      }
    },
    //图片放大
    picLarge () {
      this.picTimes += 1.5
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 6
        this.$refs.imgPic.style.transform = 'scale(6) rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 1
        this.$refs.imgPic.style.transform = 'scale(1) rotateZ(' + this.picDeg + 'deg)';
      }
    },

    //图片旋转
    picRotateLeft () {
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight () {
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    //图片选用
    lovePic () {
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      if (picLoveArray == null) {
        this.choosePicMsg.isLove = false;
        this.haslovechange = false;
      } else {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      if (!this.choosePicMsg.isLove) {
        this.loveList.push(this.choosePicMsg.id);
        this.setLoveList(this.loveList);
        this.choosePicMsg.isLove = true;

        this.haslovechange = true;

        if (!picLoveArray) {
          let pL = [];
          pL.push(this.choosePicMsg);
          sessionStorage.setItem("picLove", JSON.stringify(pL));
          this.$message.success("添加成功");
        } else {
          picLoveArray.push(this.choosePicMsg);
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          this.$message.success("添加成功");
        }
      } else {
        this.loveList.splice(this.loveList.indexOf(this.choosePicMsg.id), 1);
        this.setLoveList(this.loveList);

        this.choosePicMsg.isLove = false;

        this.haslovechange = false;

        if (picLoveArray.length === 1) {
          sessionStorage.removeItem("picLove");
          this.$message.success("移出成功");
        } else {
          let f;
          for (let i = 0; i < picLoveArray.length; i++) {
            if (this.choosePicMsg.id === picLoveArray[i].id) {
              f = i;
            }
          }
          // console.log(picLoveArray)
          picLoveArray.splice(f, 1);
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          this.$message.success("移出成功");
        }
      }

      console.log(this.choosePicMsg.isLove);
    },

    //刷新
    refresh () {
      this.isRefresh = true;

      setTimeout(() => {
        this.getPicturesAsync(this.picInfoShare.pictureIds)
        this.getUserAsync(this.picInfoShare.createUid);
      }, 500);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    //图片浏览
    dev () {
      this.$message("正在开发中……");
    },

    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //将图片删除
    deletePic () {
      this.$confirm("确定移出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let params = {
            atlasId: this.$route.query.id,
            pictureId: this.choosePicMsg.id
          };
          // this.unFormatAtlasAsync(this.atlasInfo.id)
          this.removePictureAsync(params);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //将图片设为封面
    setIndexPic () {
      this.$confirm("是否将该图片设置为封面?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let params = {
            atlasId: this.$route.query.id,
            pictureId: this.choosePicMsg.id
          };
          // this.unFormatAtlasAsync(this.atlasInfo.id)
          this.setIndexpicAsync(params);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //获取图片信息
    getPicInfo (e) {
      this.picInfo.picH = e.fileInfo.picH || "1920";
      this.picInfo.picW = e.fileInfo.picW || "1080";
      this.picInfo.format =
        e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
      this.picInfo.createAt = formatConversion(
        e.fileInfo.createAt.toString()
      ).substring(0, 10);
      this.picInfo.fileSize =
        (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";

      if (!e.exif) {
        this.picExif = {};
      } else {
        this.picExif = e.exif;
        if (e.exif.CreateAt) {
          this.picExif.CreateAtMy = formatConversion(
            this.picExif.CreateAt.toString()
          ).substring(0, 10);
        } else {
          this.picExif.CreateAtMy = null;
        }
      }
    },

    //打开图片浏览
    openDialog (i, e) {
      this.dialogVisible = true;
      this.choosePicMsg = {};
      // console.log(e)
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.id = e.id
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.type = e.type;
      if (e.type == "video") {
        this.playerOptions.sources[0].src = this.choosePicMsg.src;
      this.choosePicMsg.src = e.src;

      }
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      this.getLibInfo(e.libId)
      this.getPicInfo(e);

      this.$nextTick(() => {
        this.clearLargeAndSmall()
        this.beSurePic(i, 10);
      });
    },
    async getLibInfo (id) {
      let { status, data } = await getLib(id);
      if (status) {
        this.choosePicMsg.libName = data.name
      } else {
        this.choosePicMsg.libName = '暂无'
      }
    },
    picListClick (e, i) {
      this.clearLargeAndSmall()
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      this.getPicInfo(e);
    },

    //图片浏览中大的箭头 左边
    bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }
      this.clearLargeAndSmall()
      this.choosePicMsg.src = this.sharePic[this.choosePicMsg.myId - 1].srcW1080;
      this.choosePicMsg.srcW1080 = this.sharePic[this.choosePicMsg.myId - 1].srcW1080;
      this.choosePicMsg.desc =
        this.sharePic[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = this.sharePic[
        this.choosePicMsg.myId - 1
      ].downloadCount;
      this.choosePicMsg.labels = this.sharePic[
        this.choosePicMsg.myId - 1
      ].labels
      this.choosePicMsg.pushCount = this.sharePic[
        this.choosePicMsg.myId - 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.sharePic[
        this.choosePicMsg.myId - 1
      ].shareCount;
      this.choosePicMsg.id = this.sharePic[this.choosePicMsg.myId - 1].id;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.sharePic[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中大的箭头 右边
    bigRight () {
      if (this.choosePicMsg.myId === this.sharePic.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg.src = this.sharePic[this.choosePicMsg.myId + 1].srcW1080;
      this.choosePicMsg.srcW1080 = this.sharePic[this.choosePicMsg.myId + 1].srcW1080;
      this.choosePicMsg.desc =
        this.sharePic[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = this.sharePic[
        this.choosePicMsg.myId + 1
      ].downloadCount;
      this.choosePicMsg.labels = this.sharePic[
        this.choosePicMsg.myId + 1
      ].labels
      this.choosePicMsg.pushCount = this.sharePic[
        this.choosePicMsg.myId + 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.sharePic[
        this.choosePicMsg.myId + 1
      ].shareCount;
      this.choosePicMsg.id = this.sharePic[this.choosePicMsg.myId + 1].id;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.sharePic[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      // console.log(this.scroll)
    },

    openUpload () {
      this.$router.push({
        //核心语句
        name: "pictureUpload", //跳转的路径
        params: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          atlas: this.atlasInfo
        }
      });
    },

    //滚动加载图片
    scrollPic () {
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight ===
        document.body.offsetHeight;
      if (isBottom) {
        if (this.picList.length !== this.total) {
          this.showLoading = true;
          // this.page++;
          // let params = {
          //   id: this.$route.query.id,
          //   page: this.page,
          //   pageSize: this.pageSize
          // };
          // this.listAtlasPicturesAsync(params);
          this.showLoading = false;
        }
      }
    },

    //获取用户信息
    async getUserAsync (val) {
      let { status, data, message, pagination } = await getUser(val);
      if (status) {
        this.userInfo = data;
      }
    },

    //查询单个图片
    async getPictureAsync (val) {
      let { status, data, message, pagination } = await getPicture(val);
      if (status) {
        this.getFileInfoByIdAsync(data.fileId)
      }
    },

    //查询多个图片对象
    async getPicturesAsync (val) {
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let { status, data, message } = await getPictures({ ids: val });
      if (status) {
        this.sharePic = data

        //判断是否为选用图片
        // if (picLoveArray) {
        //   for (let index = 0; index < picLoveArray.length; index++) {
        //     for (let j = 0; j < this.sharePic.length; j++) {
        //       if (picLoveArray[index].id === this.sharePic[j].id) {
        //         this.sharePic[j].isLove = true
        //         this.loveList.push(this.sharePic[j].id)
        //       } else {
        //         this.sharePic[j].isLove = false
        //       }
        //     }
        //   }
        // }

        for (let i = 0; i < this.sharePic.length; i++) {
          this.sharePic[i].type = 'pic';
          if (this.sharePic[i].exif) {
            this.sharePic[i].exif = JSON.parse(this.sharePic[i].exif)
          }

          if (!this.sharePic[i].fileInfo.picThumbH160) {
            this.sharePic[i].src = require('@/assets/house/onloadpicin.png')
            this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicin.png')
            this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicin.png')
          } else {
            this.sharePic[i].src = picPrefix + this.sharePic[i].fileInfo.picThumbH160
            this.sharePic[i].picThumbWh160 = picPrefix + this.sharePic[i].fileInfo.picThumbWh160
            this.sharePic[i].srcW1080 = picPrefix + this.sharePic[i].fileInfo.picThumbW1080
          }

          //图片加载失败
          if (this.sharePic[i].fileInfo.picThumbH160 === 'error') {
            this.sharePic[i].src = require('@/assets/house/onloadpicerror.png')
            this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
            this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicerror.png')
          }

          let imgTest = new Image()
          imgTest.src = picPrefix + this.sharePic[i].fileInfo.picThumbH160
          imgTest.onerror = () => {
            this.sharePic[i].src = require('@/assets/house/onloadpicerror.png')
            this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
            this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicerror.png')
          }



        }
        this.getVideosAsync(this.picInfoShare.videoIds)

      }
    },

    //查询多个视频对象
    async getVideosAsync (val) {
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let { status, data, message } = await getVideos({ ids: val });
      if (status) {
        this.shareVideo = data
        console.log(this.shareVideo);
        this.shareVideo.forEach((ele) => {
          ele.type = 'video';
          ele.src=picPrefix + ele.fileInfo.savepath
        })
        this.sharePic = [...this.sharePic,...this.shareVideo]

        //判断是否为选用图片
        // if (picLoveArray) {
        //   for (let index = 0; index < picLoveArray.length; index++) {
        //     for (let j = 0; j < this.sharePic.length; j++) {
        //       if (picLoveArray[index].id === this.sharePic[j].id) {
        //         this.sharePic[j].isLove = true
        //         this.loveList.push(this.sharePic[j].id)
        //       } else {
        //         this.sharePic[j].isLove = false
        //       }
        //     }
        //   }
        // }

        // for (let i = 0; i < this.sharePic.length; i++) {
        //   if (this.sharePic[i].exif) {
        //     this.sharePic[i].exif = JSON.parse(this.sharePic[i].exif)
        //   }

        //   if (!this.sharePic[i].fileInfo.picThumbH160) {
        //     this.sharePic[i].src = require('@/assets/house/onloadpicin.png')
        //     this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicin.png')
        //     this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicin.png')
        //   } else {
        //     this.sharePic[i].src = picPrefix + this.sharePic[i].fileInfo.picThumbH160
        //     this.sharePic[i].picThumbWh160 = picPrefix + this.sharePic[i].fileInfo.picThumbWh160
        //     this.sharePic[i].srcW1080 = picPrefix + this.sharePic[i].fileInfo.picThumbW1080
        //   }

        //   //图片加载失败
        //   if (this.sharePic[i].fileInfo.picThumbH160 === 'error') {
        //     this.sharePic[i].src = require('@/assets/house/onloadpicerror.png')
        //     this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
        //     this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicerror.png')
        //   }

        //   let imgTest = new Image()
        //   imgTest.src = picPrefix + this.sharePic[i].fileInfo.picThumbH160
        //   imgTest.onerror = () => {
        //     this.sharePic[i].src = require('@/assets/house/onloadpicerror.png')
        //     this.sharePic[i].picThumbWh160 = require('@/assets/house/onloadpicerror.png')
        //     this.sharePic[i].srcW1080 = require('@/assets/house/onloadpicerror.png')
        //   }



        // }
      }
    },

    //查询单个文件
    async getFileInfoByIdAsync (val) {
      let { status, data, message, pagination } = await getFileInfoById(val);
      if (status) {
        let pic = { ...data }
        if (!data.picThumbH160) {
          pic.src = picPrefix + data.savepath;
          pic.srcW1080 =
            picPrefix + data.savepath;
        } else {
          pic.src =
            picPrefix + data.picThumbH160;
          pic.picThumbWh160 =
            picPrefix + data.picThumbWh160;
          pic.srcW1080 =
            picPrefix + data.picThumbW1080;
        }
        this.sharePic.push(pic)
      }
    },

    isJSON (str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
      console.log('It is not a string!')
    },

  },
  created () {



    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
      }
    }
    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth;

    this.picInfoShare = JSON.parse(this.$route.query.data);
    // this.getAtlasInfoAsync(this.$route.query.id)
    this.getPicturesAsync(this.picInfoShare.pictureIds)
    this.picInfoShare.pictureIdsArray = this.picInfoShare.pictureIds.split(',')
    // for (let i = 0; i < this.picInfoShare.pictureIdsArray.length; i++) {
    //   this.getPictureAsync(this.picInfoShare.pictureIdsArray[i])
    // }
    // console.log(this.picInfoShare.pictureIdsArray);
    this.getUserAsync(this.picInfoShare.createUid);

  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./sharepiclist.scss";
@import "@/constants/elHeader.scss";
::v-deep .el-select__caret:before {
  content: "\e78f";
  font-size: 16px;
  color: black;
}

.elinput ::v-deep .el-input__inner {
  height: 45px;
  line-height: 45px;
}

::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  display: flex;
  padding: 0;
}
</style>
